import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { onPointer, destroyPointer, addPointer, getMiddle, getDistance, removePointer, constrainScale } from "../utils/panzoom-utils";
import { debounce } from "lodash";
import Console from "./Console";
import Swal from 'sweetalert2';

import zips from '../../assets/zip-codes.json';

const validateZipCode = (userZipCode) => {
	const validZipCodeTest = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
	return validZipCodeTest.test(userZipCode) ? true : false;
}



const swal = () => {Swal.fire({
	title: "Enter your Zip Code so we can customize your experience and product offerings:",
	input: "text",
	inputAttributes: {
	  autocapitalize: "off"
	},
	showCancelButton: false,
	confirmButtonText: "Submit",
	showLoaderOnConfirm: true,
	preConfirm: async (zipCode) => {
		if (validateZipCode(zipCode)) {
			let isZenner = false;
			for (let stateIndex in zips.zipCodes) {
        console.log(stateIndex)
				if (stateIndex === "new-jersey") {
					isZenner = (zips.zipCodes[stateIndex].indexOf(zipCode) === -1) ? false : false;
				} else {
					isZenner = (zips.zipCodes[stateIndex].indexOf(parseInt(zipCode)) === -1) ? false : false;
				}
				if (isZenner) {
					localStorage.setItem("userState", stateIndex);
          break;
				}
			}
			localStorage.setItem("userZipCode", zipCode);
			if (isZenner) {
				localStorage.setItem("zennerOrSensus", "Sensus");
				window.location.reload();
			} else {
				localStorage.setItem("zennerOrSensus", "Sensus");
				window.location.reload();
			}

		} else {
			Swal.showValidationMessage("Request failed: Zip Code invalid.");
		}
	},
	allowOutsideClick: () => !Swal.isLoading()
  });
}

@inject("store")
@observer
class Panzoom extends Component {
  // the width and height of the image
  @observable imgWidth = 5760;
  @observable imgHeight = 3240;

  // capture initial scale for the window size
  @observable initialScale = window.innerWidth / this.imgWidth;

  // the current x, y and scale
  @observable scale = this.initialScale;
  @observable x = 0;
  @observable y = window.innerHeight - this.imgHeight * this.scale;

  // capture the initial x and y for reset
  @observable initialX = 0;
  @observable initialY = window.innerHeight - this.imgHeight * this.scale;

  // the min and max scale size (zoom)
  @observable minScale = this.initialScale;
  @observable maxScale = 2;

  // scrollwheel zomm threshold
  // smaller: more scrolls, bigger: less scrolls
  @observable scrollWheelStep = 0.3;
  @observable zoomFactor = 3;

  // in memory variables, don't change these
  // these are used to pan the map
  @observable origX;
  @observable origY;
  @observable focalX;
  @observable focalY;
  @observable startScale;
  @observable startDistance;
  @observable pointers = [];
  @observable isPanning = false;
  @observable isPinching = false;
  @observable pinchDiff;
  @observable lastTimeoutId;

  @observable isMouseUp = false;
  @observable isMouseDown = false;

  @observable touchMode = false;
  @observable isPinchingZooming = false;

  @observable log = {
    event: null
  };

  constructor(props) {
    super(props);
    this.translate = window.innerWidth <= 992 ? debounce(this.translateMethod.bind(this), 10) : this.translateMethod;
  }

  // attach all the event listeners
  componentDidMount() {
    let propOnClick = this.props.onClick.bind(this);

    if(!localStorage.getItem("zennerOrSensus")){
      swal();
    }

    // -- resolved problem --
    // on drag/swipe on a map point would cause the the popup to fire, on close of popup, zoom in/out would not work anymore
    // instead of on mouseDown, use mouseUp and compare clientX and clientY to check for drag/swipe differences
    // if they are the same, show the popup, nothing has moved.
    // if they differ, then drag/swipe is in action, don't show the popup.
    // start(pointer, event) has the actual target element we need to get the map point id
    // save it to currPointer so we can use it in end(pointer, event) (aka mouseUp)

    let currPointer, currX, currY;
    this.pointerTracker = new PointerTracker(this.element, {
      start(pointer, event) {
        // _handleDown(event);
        // Called when a pointer is pressed/touched within the element.
        // pointer - The new pointer. This pointer isn't included in this.currentPointers or this.startPointers yet.
        // event - The event related to this pointer.
        // console.log(pointer);
        // onPointerStart(pointer);
        currPointer = pointer;
        currX = event.clientX;
        currY = event.clientY;
        // onPointerStart(pointer);
        return event;
      },
      move(previousPointers, changedPointers, event) {
        // _handleMove(event)
        // Called when pointers have moved.
        // previousPointers - The state of the pointers before this event. This contains the same number  of pointers, in the same order, as this.currentPointers and this.startPointers.
        // changedPointers - The pointers that have changed since the last move callback.
        // event - The event related to the pointer changes.
      },
      end(pointer, event) {
        // if the map hasn't moved all
        if (event.clientX == currX && event.clientY == currY) {
          onPointerStart(currPointer);
        }
      }
    });

    const onPointerStart = pointer => {
      try {
        if (pointer && propOnClick) {
          propOnClick(pointer.nativePointer);
        }
      } catch (ex) {}
    };

    onPointer("down", this.element, this.handleDown.bind(this));
    onPointer("move", this.element, this.handleMove.bind(this));
    onPointer("up", this.element, this.handleUp.bind(this));

    if (window.innerWidth >= 768) {
      this.element.addEventListener("wheel", this.handleWheel.bind(this));
      document.addEventListener("keydown", this.handleKeyDown.bind(this));
      document.addEventListener("contextmenu", event => event.preventDefault());
    }

    this.props.actions({
      zoomToPoint: this.zoomToPoint.bind(this),
      zoomOut: this.handleZoomOut.bind(this),
      zoomIn: this.handleZoomIn.bind(this),
      reset: this.reset.bind(this)
    });

    if (window.innerWidth < 767) {
      setTimeout(() => {
        this.fauxAnimate({ x: this.imgWidth / 2, y: this.imgHeight / 2, toScale: 0.18 });
      }, 2500);
    } else {
      this.reset();
    }
  }

  // clean up all the event listeners
  componentWillUnmount() {
    destroyPointer("down", this.element, this.handleDown.bind(this));
    destroyPointer("move", this.element, this.handleMove.bind(this));
    destroyPointer("up", this.element, this.handleUp.bind(this));
    this.element.removeEventListener("wheel", this.handleWheel.bind(this));
    document.removeEventListener("keydown", this.handleKeyDown.bind(this));
  }

  fauxAnimate({ x, y, toScale }) {
    let scale = this.initialScale;
    const intervalId = setInterval(() => {
      if (!this.props.store.loading) {
        if (scale.toFixed(2) > toScale.toFixed(2)) return clearInterval(intervalId);
        const e = new Event("wheel");
        scale += 0.01;
        e.deltaX = -0;
        e.deltaY = -100;
        e.pageX = (x / 2) * scale;
        e.pageY = (y / 2) * scale;
        this.handleWheel(e);
      }
    }, 55);
  }

  reset() {
    this.x = this.initialY;
    this.y = this.initialX;
    this.scale = this.minScale;
    this.translate();
  }

  /**
   * Pans and zooms the map to an x, y cordinate
   */
  translateMethod(options) {
    const transitionDuration = 1000;

    // set the animation, if enabled
    if (options?.animate) {
      this.element.style.transition = `scale ${transitionDuration}ms ease-in-out`;
    }

    // keep the x,y inside the container
    this.containMap();

    // pan/zoom the map
    this.element.style.transform = `translate(${this.x}px, ${this.y}px) scale(${this.scale})`;
    // this.element.style.webkitTransform = `translate(${this.x}px, ${this.y}px) scale(${this.scale})`;

    // send back the onChange event
    if (this.props.onChange) this.props.onChange({ x: this.x, y: this.y, scale: this.scale });

    // turn off the animation
    // this important so we don't animate panning or scroll wheel
    if (options?.animate) {
      let timeout = setTimeout(() => {
        if (timeout == this.lastTimeoutId) {
          this.element.style.transition = `none`;
        }
      }, transitionDuration + 150);
      this.lastTimeoutId = timeout;
    }
  }

  /**
   * Keep the map inside the container
   * This should be called before css translate
   * Mutates x, y state
   */
  containMap() {
    // capture the scaled width and height diff depending on the window size
    const iWidth = this.imgWidth * this.scale;
    const iHeight = this.imgHeight * this.scale;
    const widthDiff = Math.abs(window.innerWidth - iWidth);
    const heightDiff = Math.abs(window.innerHeight - iHeight);

    const maxX = 0; // Always 0
    const minX = -widthDiff; // -Math.abs(iW - sW)
    const maxY = this.scale < 0.4 ? heightDiff : 0; // allow the image to doc bottom on portrat windows
    const minY = iHeight > window.innerHeight ? -heightDiff : 0; // -Math.abs(iH - sH)

    // force x, y to be in range
    this.x = Math.min(Math.max(this.x, minX), maxX);
    this.y = Math.min(Math.max(this.y, minY), maxY);
  }

  /**
   * Calculates x y cordinates then calls translate to pan/zomm the map
   * @param {number} toScale the new zoom scale
   * @param {object} point the x and y cordinate at 100% scale
   * @param {object?} options optional options
   */
  zoomToPoint(toScale, point, options) {
    // console.log('RAN')
    const hasNewScale = this.scale != toScale;

    this.x = -point.x * toScale + window.innerWidth / 2;
    this.y = -point.y * toScale + window.innerHeight / 2;
    this.scale = toScale;

    // disable animation when when there's a new scale
    // because we're top left, 0, 0
    options = options || {};
    options.animate = hasNewScale ? false : options.animate;

    this.translate(options);
  }

  // ---------------------------------------------------------
  // Event Listeners
  // ---------------------------------------------------------
  handleDown = event => {
    // console.log('handleDown')
    this.log.event = event.type;
    this.element.style.cursor = "move";

    if (this.pointerTracker.currentPointers.length == 1) {
      this.isPanning = true;
      this.isPinching = false;
    } else {
      this.isPinching = true;
      this.isPanning = false;
    }

    event.preventDefault();
    // event.stopPropagation();

    this.origX = this.x;
    this.origY = this.y;

    // AHHHHHHHHHHHH
    const point = getMiddle(this.pointerTracker.currentPointers[0], this.pointerTracker.currentPointers[1]);
    this.focalX = point.clientX;
    this.focalY = point.clientY;
    this.startScale = this.scale;
    this.startDistance = getDistance(this.pointerTracker.currentPointers);
  };

  handleMove = event => {
    if (this.isPanning || this.isPinching) {
      this.log.event = event.type;

      event.preventDefault();
      // event.stopPropagation();

      if (this.pointerTracker.currentPointers.length == 2) {
        this.isPinchingZooming = true;
        const point1 = this.pointerTracker.currentPointers[0];
        const point2 = this.pointerTracker.currentPointers[1];

        const currDist = Math.hypot(point1.pageX - point2.pageX, point1.pageY - point2.pageY);
        const diff = currDist - this.startDistance;
        this.pinchDiff = diff;

        const toScale = constrainScale((diff * this.scrollWheelStep) / 80 + this.startScale, this.minScale, this.maxScale);

        // determine the point on where the slide is zoomed in
        var zoom_target = { x: 0, y: 0 };
        zoom_target.x = (this.focalX - this.x) / this.scale;
        zoom_target.y = (this.focalY - this.y) / this.scale;

        // calculate x and y based on zoom
        this.x = -zoom_target.x * toScale + this.focalX;
        this.y = -zoom_target.y * toScale + this.focalY;
        this.scale = toScale;

        const point = getMiddle(this.pointerTracker.currentPointers[0], this.pointerTracker.currentPointers[1]);
        this.focalX = point.clientX;
        this.focalY = point.clientY;

        this.origX = this.x;
        this.origY = this.y;
      } else {
        // console.log(this.pointerTracker);
        const point = getMiddle(this.pointerTracker.currentPointers[0], this.pointerTracker.currentPointers[1]);
        this.isPinchingZooming = false;
        this.x = this.origX + (point.clientX - this.focalX);
        this.y = this.origY + (point.clientY - this.focalY);
      }

      this.translate();
      // console.log(event)
    }
  };
  handleUp = event => {
    this.log.event = event.type;
    event.preventDefault();

    // TODO: after two finger pinch zooming, allow 1 finger to pan without letting go and re-touching
    this.isPanning = false;
    this.isPinching = false;
    this.touchMode = false;
    this.element.style.cursor = "initial";
  };
  handleWheel = e => {
    var zoom_target = { x: 0, y: 0 };
    var zoom_point = { x: e.pageX, y: e.pageY };

    // console.log(e)

    e.preventDefault();
    var delta = e.deltaY === 0 && e.deltaX ? e.deltaX : e.deltaY;

    // determine the point on where the slide is zoomed in
    zoom_target.x = (zoom_point.x - this.x) / this.scale;
    zoom_target.y = (zoom_point.y - this.y) / this.scale;

    // apply zoom
    const wheel = delta < 0 ? 1 : -1;
    const toScale = constrainScale(this.scale * Math.exp((wheel * this.scrollWheelStep) / 3), this.minScale, this.maxScale);

    // calculate x and y based on zoom
    this.x = -zoom_target.x * toScale + zoom_point.x;
    this.y = -zoom_target.y * toScale + zoom_point.y;
    this.scale = toScale;

    this.translate();
  };
  handleZoom({ direction }) {
    var zoom_target = { x: 0, y: 0 };
    var zoom_point = { x: window.innerWidth / 2, y: window.innerHeight / 2 };

    // determine the point on where the slide is zoomed in
    zoom_target.x = (zoom_point.x - this.x) / this.scale;
    zoom_target.y = (zoom_point.y - this.y) / this.scale;

    const zoomFactorIn = this.scale * Math.exp(this.scrollWheelStep / 3);
    const zoomFactorOut = this.scale * Math.exp(-this.scrollWheelStep / 3);

    // apply zoom
    const toScale = constrainScale(direction == "in" ? zoomFactorIn : zoomFactorOut, this.minScale, this.maxScale);

    // calculate x and y based on zoom
    this.x = -zoom_target.x * toScale + zoom_point.x;
    this.y = -zoom_target.y * toScale + zoom_point.y;
    this.scale = toScale;

    this.translate();
  }
  handleZoomOut() {
    this.handleZoom({ direction: "out" });
    // ga("send", "event", "LB City", "Map", `Zoom Out Button`);
    dataLayer.push({
      'event': 'gaEvent',
      'eventCategory': 'LB City - ' + this.props.store.layer,
      'eventAction': `Zoom Out Button`,
      'eventLabel': 'Map'
    });
  }
  handleZoomIn() {
    this.handleZoom({ direction: "in" });
    // ga("send", "event", "LB City", "Map", `Zoom In Button`);
    dataLayer.push({
      'event': 'gaEvent',
      'eventCategory': 'LB City - ' + this.props.store.layer,
      'eventAction': `Zoom In Button`,
      'eventLabel': 'Map'
    });
  }
  handleKeyDown(event) {
    // prevent Ctrl++, Ctrl+- and Ctrl+0
    if (event.ctrlKey) {
      if (event.keyCode == 107 || event.keyCode == 187 || event.keyCode == 61) event.preventDefault();
      if (event.keyCode == 109 || event.keyCode == 189) event.preventDefault();
      // if (event.keyCode == 96 || event.keyCode == 48) event.preventDefault();
    }
  }

  render() {
    return (
      <>
        {/* <Console logs={this.logs} /> */}
        {/* <div className="dev-console">
          <div
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(
                {
                  userSelect: "none",
                  touchAction: "none",
                  width: `${this.imgWidth}px`,
                  height: `${this.imgHeight}px`,
                  transformOrigin: "0 0",
                  transition: `none 0s ease`,
                  WebkitTransform: `translate3d(0,0, 0) translate(${this.x}px, ${this.y}px) scale(${this.scale})`,
                  msTransform: `translate3d(0,0, 0) translate(${this.x}px, ${this.y}px) scale(${this.scale})`,
                  msTransform: `translate3d(0,0, 0) translate(${this.x}px, ${this.y}px) scale(${this.scale})`,
                  transform: `translate3d(0,0, 0) translate(${this.x}px, ${this.y}px) scale(${this.scale})`
                },
                null,
                2
              )
            }}
          ></div> */}
        {/* <div>
            <strong>Event: </strong>
            {this.log.event}
          </div>
          <div>
            <strong>Mode: </strong> {this.touchMode ? "Touch" : " Pointer"}
          </div>
          <div>
            <strong>Panning: </strong> {this.isPanning.toString()}
          </div>
          <div>
            <strong>Pinching: </strong> {this.isPinching.toString()}
          </div>
          <div>
            <strong>Pinch Diff: </strong> {this.pinchDiff}
          </div>
          <div>
            <strong>Pinch Zoom: </strong> {this.isPinchingZooming.toString()}
          </div>
          <div>
            <strong>X: </strong> {this.x}
          </div>
          <div>
            <strong>Y: </strong> {this.y}
          </div>
          <div>
            <strong>Scale: </strong> {this.scale}
          </div>
          <div>
            <strong>Orig X: </strong> {this.origX}
          </div>
          <div>
            <strong>Orig Y: </strong> {this.origY}
          </div>
          <div>
            <strong>Focal X: </strong> {this.focalX}
          </div>
          <div>
            <strong>Focal Y: </strong> {this.focalY}
          </div>
          <div>
            <strong>Distance: </strong> {this.startDistance}
          </div>
          <div>
            <strong>Pointers: </strong> {this.pointerTracker?.currentPointers?.length}
          </div> */}
        {/* </div> */}
        <div
          style={{
            overflow: "hidden",
            userSelect: "none",
            touchAction: "none"
          }}
        >
          <div className="map-controls">
            <button className="map-controls--zoomOut" onClick={() => this.handleZoomOut()}>
              <i className="far fa-minus"></i>
            </button>
            <button className="map-controls--zoomIn" onClick={() => this.handleZoomIn()}>
              <i className="far fa-plus"></i>
            </button>
            <button className="map-controls--changeZip" onClick={swal}>Change Zip Code</button>
          </div>
          
          <div
            ref={node => (this.element = node)}
            className={`${this.props.className} ${this.props.store.loading ? "" : this.props.classNameAfterLoad}`}
            style={{
              userSelect: "none",
              touchAction: "none",
              width: `${this.imgWidth}px`,
              height: `${this.imgHeight}px`,
              transformOrigin: "0 0",
              transition: `none 0s ease`
              // WebkitTransform: `translate3d(0,0, 0) translate(${this.x}px, ${this.y}px) scale(${this.scale})`,
              // msTransform: `translate3d(0,0, 0) translate(${this.x}px, ${this.y}px) scale(${this.scale})`,
              // msTransform: `translate3d(0,0, 0) translate(${this.x}px, ${this.y}px) scale(${this.scale})`
              // transform: `translate3d(0,0, 0) translate(${this.x}px, ${this.y}px) scale(${this.scale})`
            }}
          >
            {this.props.children}
          </div>
        </div>
      </>
    );
  }
}

export default Panzoom;
